define('OutSystems/ClientRuntime/modules/LogTable/LogTableInfo',["require", "exports", "../Database/AutoNumber", "../Database/DBDataType"], function (require, exports, AutoNumber_1, DBDataType_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LOG_FIELDS = void 0;
    exports.LOG_FIELDS = {
        Instant: "INSTANT",
        LogType: "LOGTYPE",
        Message: "MESSAGE",
        ModuleName: "MODULENAME",
        Stack: "STACK",
        MessageType: "MESSAGETYPE",
        ExtraInfo: "EXTRAINFO",
    };
    var createLogTableColumns = function () {
        var result = [];
        Object.keys(exports.LOG_FIELDS).forEach(function (key) {
            result.push({
                name: key,
                columnName: exports.LOG_FIELDS[key],
                type: DBDataType_1.default.TEXT,
            });
        });
        return result;
    };
    var LOG_TABLE_INFO = {
        tableName: "OSSYS_LOG",
        idIsAutoNumber: AutoNumber_1.default.YesIfEmpty,
        attributes: createLogTableColumns(),
    };
    exports.default = LOG_TABLE_INFO;
});
//# sourceMappingURL=LogTableInfo.js.map;
